/* eslint-disable prefer-template */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable no-unneeded-ternary */
import React from 'react';
import Moment from 'react-moment';
import styles from './log.module.scss';
import UserImg from '../../../../icons/default_avatar.jpg';
import { renderInfoForType } from '../../../../utils/helpers';

const Log = ({ log, image, myForms }) => (
    <div className={`${styles.root} ${myForms && styles.usePaddingSty}`}>
      <div className={styles.first}>
        {log.badge
        ? <div className={styles.content}>
            <span style={{ color: '#242E42' }}>Sent back to Signatory Review</span>&nbsp;
            <span>by</span>&nbsp;
            <span style={{ textTransform: 'capitalize' }}>{log?.commented_by?.fullname}</span>&nbsp;
            <span>on</span>
            <span>
              <Moment format=" MM/DD/YYYY " local>
                {log.current_date}
              </Moment>
              at
              <Moment format=" hh:mm A" local>
                {log.current_date}
              </Moment>
            </span>
          </div>
          :(log?.classifier === 0 && (log?.inspection_dict?.source === 'inspection'|| log.form_dict?.source === 'form'))
          ? <div className={styles.firststyle}>
              {log.inspection_dict?.source === 'inspection'
              ?<h4 style={{ marginBottom: 0, display: 'flex', alignItems: 'center', fontSize: '19px' }}>
                  <img className={styles.image} src={image ? image : UserImg} alt="" />
                  &nbsp;&nbsp;{log.inspection_dict.message}
               </h4>
                : (log.form_dict?.source === 'form' && (
                  <h4 style={{ marginBottom: 0, display: 'flex', alignItems: 'center', fontSize: '19px', fontWeight: myForms && 700 }}>
                    <img className={styles.image} src={log.form_dict.image ? log.form_dict.image : UserImg} alt="" />
                    &nbsp;&nbsp;{log.form_dict.message}
                  </h4>
                ))
              }
              <span>
                <Moment format=" MM/DD/YY " local>
                  {log.date}
                </Moment>
                at
                <Moment format=" hh:mm A" local>
                  {log.date}
                </Moment>
              </span>
            </div>
            :(log.classifier === 0 && log.inspection_dict?.source === 'remark'
            ?<div className={styles.secondstyle}>
                <div className={styles.subinner}>
                  <div className={styles.custom}>
                    <h4>
                      <img className={styles.image} src={image} alt="" />&nbsp;&nbsp;{log.inspection_dict.user} added remark
                    </h4>
                    <span className={styles.lable}>{log.inspection_dict.title}</span>
                    <span className={styles.lable}>{log.inspection_dict.value}</span>
                  </div>
                  <span className={styles.gray}>
                    <Moment format=" MM/DD/YY " local>
                      {log.date}
                    </Moment>
                    at
                    <Moment format=" hh:mm A" local>
                      {log.date}
                    </Moment>
                  </span>
                </div>
                <div>
                  <span className={styles.fromto} style={{ flexDirection: 'column' }}>
                    <p className={styles.gray} style={{ width: '100%' }}>FROM:</p>{log.inspection_dict.from}
                  </span>
                  <span className={styles.fromto} style={{ flexDirection: 'column' }}>
                    <p className={styles.gray} style={{ width: '100%' }}>TO:</p> {log.inspection_dict.to}
                  </span>
                </div>
             </div>
              :(log.classifier === 0 && (log.inspection_dict?.source === 'workorder' || log.inspection_dict?.source === 'disconnect_connect_workorders')
              ? <div className={styles.secondstyle}>
                  <div className={styles.subinner}>
                    <div className={styles.custom}>
                      <h4><img className={styles.image} src={image} alt="" />&nbsp;&nbsp;{log.inspection_dict.message}</h4>
                    </div>
                    <span className={styles.gray}>
                      <Moment format=" MM/DD/YY " local>
                        {log.date}
                      </Moment>
                      at
                      <Moment format=" hh:mm A" local>
                        {log.date}
                      </Moment>
                    </span>
                  </div>
                  <div>
                    <span className={styles.fromto}>
                      <p className={styles.gray}>category &nbsp;&nbsp;<span style={{ color: 'black', fontSize: '15px', paddingRight: '10px' }}>{log.inspection_dict.title}</span></p>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <p className={styles.gray}>sub category &nbsp;&nbsp;<span style={{ color: 'black', fontSize: '15px', paddingRight: '10px' }}>{log.inspection_dict.value}</span></p>
                      </div>
                    </span>
                  </div>
                </div>
                : (log.classifier === 0 && log?.source)
                && <div className={styles.content}>
                <span style={{ color: '#242E42', fontSize: '16px' }}>{log?.description}</span>&nbsp;
                <div>
                  <span>by</span>&nbsp;
                  <span style={{ textTransform: 'capitalize', color: '#3A61A8' }}>{log?.logged_by?.fullname}</span>&nbsp;
                  <span>on </span>
                  <span>
                    {renderInfoForType({ 'type': 'date' }, log?.date, null, null)}
                    {' '} at {' '}
                    {renderInfoForType({ 'type': 'time' }, log?.date, null, null)}
                  </span>
                </div>
                   </div>
              ))
        }
        {
          (log.classifier === 1 && (log.inspection_dict?.source === 'remark' || log.inspection_dict?.source === 'inspection'))
          ? <div className={styles.secondstyle}>
              {log.inspection_dict?.source === 'remark'
              ? <div>
                  {log.inspection_dict.log_type === 'remark_image'
                  ? <div>
                      <div className={styles.subinner}>
                        <div className={styles.custom}>
                          <h4>
                            <img className={styles.image} src={image} alt="" />&nbsp;&nbsp;{log.inspection_dict.user} {log.inspection_dict.from}
                          </h4>
                          <span className={styles.lable}>{log.inspection_dict.title}</span>
                          <span className={styles.lable}>{log.inspection_dict.value}</span>
                        </div>
                        <span className={styles.gray}>
                          <Moment format=" MM/DD/YY " local>
                            {log.date}
                          </Moment>
                          at
                          <Moment format=" hh:mm A" local>
                            {log.date}
                          </Moment>
                        </span>
                      </div>
                    </div>
                  : <div>
                      <div className={styles.subinner}>
                        <div className={styles.custom}>
                          <h4>
                            <img className={styles.image} src={image} alt="" />&nbsp;&nbsp;{log.inspection_dict.user} changed remark
                          </h4>
                          <span className={styles.lable}>{log.inspection_dict.title}</span>
                          <span className={styles.lable}>{log.inspection_dict.value}</span>
                        </div>
                        <span className={styles.gray}>
                          <Moment format=" MM/DD/YY " local>
                            {log.date}
                          </Moment>
                          at
                          <Moment format=" hh:mm A" local>
                            {log.date}
                          </Moment>
                        </span>
                      </div>
                      <div>
                        <span className={styles.fromto} style={{ flexDirection: 'column' }}>
                          <p className={styles.gray} style={{ width: '100%' }}>FROM:</p>{log.inspection_dict.from}
                        </span>
                        <span className={styles.fromto} style={{ flexDirection: 'column' }}>
                          <p className={styles.gray} style={{ width: '100%' }}>TO:</p> {log.inspection_dict.to}
                        </span>
                      </div>
                    </div>}
                </div>
                :<>
                  {(log.inspection_dict?.source === 'inspection' && log.inspection_dict.log_type === 'checkbox')
                  ? <div className={styles.subinner}>
                      <div className={styles.custom}>
                        <h4>
                          <img className={styles.image} src={image} alt="" />&nbsp;&nbsp;{log.inspection_dict.user} updated checkbox
                        </h4>
                        <span className={styles.lable}>{log.inspection_dict.title}</span>
                        <h4 style={{ marginTop: '0px' }}>{log.inspection_dict.from}</h4>
                      </div>
                      <span className={styles.gray}>
                        <Moment format=" MM/DD/YY " local>
                          {log.date}
                        </Moment>
                        at
                        <Moment format=" hh:mm A" local>
                          {log.date}
                        </Moment>
                      </span>
                    </div>
                  : <div>
                      <div className={styles.subinner}>
                        <div className={styles.custom}>
                          <h4><img className={styles.image} src={image} alt="" />&nbsp;&nbsp;{log.inspection_dict.user} updated</h4>
                          <span className={styles.lable}> {log.inspection_dict.title}</span>
                          {log.inspection_dict.sub_value && log.inspection_dict.log_type === 'remark_status'
                          && <span className={styles.lable}> {log.inspection_dict.value}</span>}
                          {log.inspection_dict.log_type === 'remark_status'
                          && <h4 style={{ marginTop: '0px' }}>status</h4>
                          }
                        </div>
                        <span className={styles.gray}>
                          <Moment format=" MM/DD/YY " local>
                            {log.date}
                          </Moment>
                          at
                          <Moment format=" hh:mm A" local>
                            {log.date}
                          </Moment>
                        </span>
                      </div>
                      {log.inspection_dict.log_type === 'remark_status'
                      ? <div>
                          <span className={styles.fromto}>
                            <span style={{ color: '#4262A3', fontSize: '17px' }}>{log.inspection_dict.sub_value}</span>
                            <div style={{ display: 'flex', padding: '0px 30px', alignItems: 'center' }}>
                              <p className={styles.gray}>from &nbsp;&nbsp;</p>
                              <span style={log.inspection_dict.from === 'SATISFACTORY' ? { color: '#6DD400' } : { color: '#E73442' }}>{log.inspection_dict.from}</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <p className={styles.gray}>to &nbsp;&nbsp;</p>
                              <span style={log.inspection_dict.to === 'UNSATISFACTORY' ? { color: '#E73442' } : { color: '#6DD400' }}>{log.inspection_dict.to}</span>
                            </div>
                          </span>
                        </div>
                      : <div>
                          <div>
                            <span className={styles.fromto} style={{ flexDirection: 'column' }}>
                              <p className={styles.gray} style={{ width: '100%' }}>FROM:</p>
                              {log.inspection_dict.log_type === 'date'
                              ? <Moment format=" MM/DD/YYYY " local>
                                  {log.inspection_dict.from}
                                </Moment>
                              : <>
                                  {log.inspection_dict.log_type === 'datetime'
                                  ? <Moment format=" MM/DD/YYYY hh:mm A " local>
                                      {log.inspection_dict.from}
                                    </Moment>
                                    :log.inspection_dict.from
                                  }
                                </>
                              }
                            </span>
                            <span className={styles.fromto} style={{ flexDirection: 'column' }}>
                              <p className={styles.gray} style={{ width: '100%' }}>TO:</p>
                              {log.inspection_dict.log_type === 'date'
                                ?<Moment format=" MM/DD/YYYY " local>
                                  {log.inspection_dict.to}
                                 </Moment>
                                :<>
                                  {log.inspection_dict.log_type === 'datetime'
                                  ? <Moment format=" MM/DD/YYYY hh:mm A " local>
                                      {log.inspection_dict.to}
                                    </Moment>
                                    :<>
                                      {log.inspection_dict.to}
                                     </>
                                  }
                                 </>
                              }
                            </span>
                          </div>
                        </div>
                      }
                    </div>
                  }
                 </>
              }
            </div>
            :(log.classifier === 1 && log.form_dict?.source === 'form')
            ?<div className={styles.secondstyle}>
                {(log.form_dict.log_type === 'form_data' || log.form_dict.log_type === 'datetime'
                ||log.form_dict.log_type === 'date' || log.form_dict.log_type === 'time')
                ? <div>
                    <div className={styles.subinner}>
                      <div className={styles.custom}>
                        <h4>
                          <img className={styles.image} src={log.form_dict.image ? log.form_dict.image : UserImg} alt="" />&nbsp;&nbsp;{log.form_dict.user} updated
                        </h4>
                        <span className={styles.lable}>{log.form_dict.title}</span>
                      </div>
                      <span className={styles.gray}>
                        <Moment format=" MM/DD/YY " local>
                          {log.date}
                        </Moment>
                        at
                        <Moment format=" hh:mm A" local>
                          {log.date}
                        </Moment>
                      </span>
                    </div>
                    <div>
                      <span className={styles.fromto} style={{ flexDirection: 'column' }}>
                        <p className={styles.gray} style={{ width: '100%' }}>FROM:</p>
                        {log.form_dict.log_type === 'datetime'
                        ? <Moment format=" MM/DD/YYYY hh:mm A " local>
                            {log.form_dict.from}
                          </Moment>
                          : log.form_dict.log_type === 'time'
                          ? <Moment format=" hh:mm A " local>
                              {log.form_dict.from}
                            </Moment>
                            : log.form_dict.log_type === 'date'
                            ? <Moment format=" MM/DD/YYYY " local>
                                {log.form_dict.from}
                              </Moment>
                              : log.form_dict.from
                        }
                      </span>
                      <span className={styles.fromto} style={{ flexDirection: 'column' }}>
                        <p className={styles.gray} style={{ width: '100%' }}>TO:</p>
                        {log.form_dict.log_type === 'datetime'
                        ? <Moment format=" MM/DD/YYYY hh:mm A " local>
                            {log.form_dict.to}
                          </Moment>
                          : log.form_dict.log_type === 'time'
                          ? <Moment format=" hh:mm A " local>
                              {log.form_dict.to}
                            </Moment>
                            : log.form_dict.log_type === 'date'
                            ? <Moment format=" MM/DD/YYYY " local>
                                {log.form_dict.to}
                              </Moment>
                              : log.form_dict.to
                        }
                      </span>
                    </div>
                  </div>
                  : (log.form_dict?.source === 'form' && log.form_dict.log_type === 'checkbox')
                ? <>
                  <div className={styles.subinner}>
                      <div className={styles.custom}>
                        <h4>
                          <img className={styles.image} src={log.form_dict.image ? log.form_dict.image : UserImg} alt="" />&nbsp;&nbsp;{log.form_dict.user} updated checkbox
                        </h4>
                        <span className={styles.lable}>{log.form_dict.title}</span>
                        <h4 style={{ marginTop: '0px' }}>{log.form_dict.from}</h4>
                      </div>
                      <span className={styles.gray}>
                        <Moment format=" MM/DD/YY " local>
                          {log.date}
                        </Moment>
                        at
                        <Moment format=" hh:mm A" local>
                          {log.date}
                        </Moment>
                      </span>
                  </div>
                  </>
                : (log.form_dict?.source === 'form' && (log.form_dict.log_type === 'attachments' || log.form_dict.log_type === 'map_location'))
                && <div className={styles.subinner}>
                      <div className={styles.custom}>
                        <h4>
                          <img className={styles.image} src={log.form_dict.image ? log.form_dict.image : UserImg} alt="" />
                          &nbsp;&nbsp;{log.form_dict.user} {log.form_dict.message}
                        </h4>
                        <span className={styles.lable}>{log.form_dict.title}</span>
                      </div>
                      <span className={styles.gray}>
                        <Moment format=" MM/DD/YY " local>
                          {log.date}
                        </Moment>
                        at
                        <Moment format=" hh:mm A" local>
                          {log.date}
                        </Moment>
                      </span>
                   </div>
                }
             </div>
            : (log.classifier === 1 && log?.source
            &&<div>
                <div className={styles.content}>
                  <p style={{ color: '#242E42', fontSize: '16px' }}>{log.description}</p>
                  <span>by</span>
                  <span style={{ marginLeft: '0.3rem', color: '#3A61A8', textTransform: 'capitalize' }}>
                    {log.logged_by?.fullname ?? ''}
                  </span>
                  <span>
                    <Moment format=" on MM/DD/YYYY " local>
                      {log.date}
                    </Moment>
                    at
                    <Moment format=" hh:mm A" local>
                      {log.date}
                    </Moment>
                  </span>
                </div>
                <div style={{ marginTop: '15px' }}>
                  {log?.meta_data && log.meta_data?.reason && (
                    <span>{log.meta_data.reason}</span>
                  )}
                </div>
              </div>
            )
        }

        {
          log.classifier === 2 && (
            <div className={styles.content}>
              <span style={{ color: '#242E42' }}>{log.description + ' '}</span>
              <span style={{ color: '#3A61A8', textTransform: 'capitalize' }}>{log.tags.user.first_name}</span>
              <span> by </span>
              <span style={{ color: '#3A61A8', textTransform: 'capitalize' }}>{log.logged_by.first_name}</span>
              <span>
                <Moment format=" on MM/DD/YYYY " local>
                  {log.date}
                </Moment>
                at
                <Moment format=" hh:mm A" local>
                  {log.date}
                </Moment>
              </span>
            </div>
          )
        }
        {
          log.classifier === 3 && (
            <div className={styles.content}>
              <span style={{ color: '#242E42' }}>{log.description}</span>&nbsp;
              <span>by</span>&nbsp;
              <span style={{ textTransform: 'capitalize' }}>{log.logged_by.fullname}</span>&nbsp;
              <span>
                <Moment format=" on MM/DD/YYYY " local>
                  {log.date}
                </Moment>
                at
                <Moment format=" hh:mm A" local>
                  {log.date}
                </Moment>
              </span>
            </div>
          )
        }
        <div className={styles.action}>{/* <span>Action</span> */}</div>
      </div>
    </div>
  );

export default Log;
